// extracted by mini-css-extract-plugin
export var header = "PageNavbar-module--header--2BkBn";
export var headerBackground = "PageNavbar-module--header--background--1Qh2a";
export var header__logo = "PageNavbar-module--header__logo--1pmNS";